import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
    body{
        background-color: #FBFBFB;
        /* color:#fff; */
        padding: 0;
        font-size: 14px;
    }
    * {
        box-sizing: border-box;
    }
`;
